import notFoundPage from "@/views/sharedPages/404.vue";
import errorPage from "@/views/sharedPages/Error.vue";

export default [
  {
    path: "/404",
    name: "notFound",
    component: notFoundPage,
    layout: "LayoutError"
  },
  {
    path: "/error",
    name: "errorPage",
    component: errorPage,
    layout: "LayoutError"
  }
];
